export default __webpack_public_path__ + "static/media/ghost.963c0fcb.png";